import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { coachingReducer } from '../features/coaching'
import { preferencesReducer } from '../features/preferences'
import { profileReducer } from '../features/profile'
import { activityTimerRuntimeReducer } from '../features/timer/model/activityTimerSlice'
import { modalSlice } from './modalSlice'

const appReducer = combineReducers({
  activityTimer: activityTimerRuntimeReducer,
  coaching: coachingReducer,
  modal: modalSlice.reducer,
  preferences: preferencesReducer,
  profile: profileReducer,
})

export const USER_SESSION_CLEARED = 'auth/userSessionCleared'
export const userSessionCleared = () => ({ type: USER_SESSION_CLEARED })

const rootReducer = (state, action) => {
  if (action.type === USER_SESSION_CLEARED) {
    state = { preferences: state?.preferences }
  }
  return appReducer(state, action)
}

export const createAppStore = (preloadedState) => configureStore({
  reducer: rootReducer,
  preloadedState,
})

export const store = createAppStore()
